import React from 'react';
import { type PhysicalReader, type LogicalReader, type Door } from '../App';
import ReaderItem from './ReaderItem';
type ReadersListProps = {
  readers: PhysicalReader[];
  logicalReaders: LogicalReader[];
  doors: Door[];
  onAssignReader: (serialNumber: string, logicalReaderId: string | null) => void;
  onCreateReader: (serialNumber?: string) => void;
  onPingReader: (serialNumber: string) => void;
  onConfirmReader: (serialNumber: string) => void;
  onStopBlinking: (serialNumber: string) => void;
};
const ReadersList = ({
  readers,
  logicalReaders,
  doors,
  onAssignReader,
  onCreateReader,
  onPingReader,
  onConfirmReader,
  onStopBlinking
}: ReadersListProps) => {
  if (readers.length === 0) {
    return <div className="flex flex-col items-center justify-center h-full" data-id="element-94">
        <p className="text-gray-500 text-center" data-id="element-95">
          No keycard readers found. Try scanning again.
        </p>
      </div>;
  }
  return <div className="space-y-4" data-id="element-96">
      <p className="text-gray-600 mb-2" data-id="element-97">
        {readers.length} keycard reader{readers.length !== 1 ? 's' : ''} found
      </p>
      {readers.map(reader => <ReaderItem key={reader.serialNumber} reader={reader} logicalReaders={logicalReaders} doors={doors} onAssignReader={onAssignReader} onCreateReader={onCreateReader} onPingReader={onPingReader} onConfirmReader={onConfirmReader} onStopBlinking={onStopBlinking} data-id="element-98" />)}
    </div>;
};
export default ReadersList;